<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.6089 10.3493C16.9399 9.97851 16.9076 9.40958 16.5368 9.07858C16.166 8.74758 15.5971 8.77986 15.2661 9.15067L11.0922 13.8266L9.27321 11.9381C8.92838 11.5801 8.35863 11.5695 8.00064 11.9143C7.64264 12.2591 7.63197 12.8289 7.97679 13.1869L10.4691 15.7744C10.6429 15.9548 10.8839 16.0546 11.1344 16.0498C11.3848 16.0451 11.6219 15.9362 11.7887 15.7493L16.6089 10.3493Z"
      fill="white"
      fill-opacity="0.9"
    />
  </svg>
</template>
